import VehicleBrands from "src/container/Administration/VehicleBrands";
import VehicleModels from "src/container/Administration/VehicleModels";
import VehicleTypes from "src/container/Administration/VehicleTypes";

import SettingsLayout from "./SettingsLayout";
import { vehicleSettingsTabs } from "./settingsRoutes";

type VehicleSettingsTab = "brand" | "model" | "type";

interface VehicleSettingsPageProps {
  tab: VehicleSettingsTab;
}

const vehicleSettingsContent = {
  brand: <VehicleBrands />,
  model: <VehicleModels />,
  type: <VehicleTypes />,
};

const VehicleSettingsPage = ({ tab }: VehicleSettingsPageProps) => (
  <SettingsLayout titleKey="vehicle_settings" activeKey={tab} tabs={vehicleSettingsTabs}>
    {vehicleSettingsContent[tab]}
  </SettingsLayout>
);

export default VehicleSettingsPage;
